import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { EapTypeViewComponent } from './eap-type-view/eap-type-view.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-eap-type',
  templateUrl: './eap-type.component.html',
  styleUrls: ['./eap-type.component.scss']
})
export class EapTypeComponent implements OnInit {

  heading: string;
  gridApi: GridApi;
  columnDefs:any[];
  operations :any[];
  tempoperations: any[];
  Statuslist: any = [];
  rowData;
  advanceSearch;
  selectedRow;
  collapesedOrNot;
  isSettings:boolean=false;
  ETypeForm: UntypedFormGroup;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {

  }

  ngOnInit() {
    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }
    ];

    this.ETypeForm = new UntypedFormGroup({
      NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
      RecordSateExt: new UntypedFormControl(""),
      ID: new UntypedFormControl("")
    });

    this.columnDefs = [

      {
        "headerName": "EAP Type",
        "field": "NAME"
      },

      {
        "headerName": "Status",
        "field":"RecordSateExt"
      }

    ];

    this.tempoperations = [ ];

      if(this.commonService.getScreenPermission("504","V")){
        this.isSettings=true;
        this.tempoperations.push({
          "name": "View",
            "id": "view"
        });
      }
      if(this.commonService.getScreenPermission("504","E")){
        this.isSettings=true;
        this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }

    if(this.commonService.getScreenPermission("504","D")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Delete",
        "id": "Delete"
      });
    }

    if(this.commonService.getScreenPermission("504","N")){
      this.tempoperations.push({
        "name": "Add EAP Type",
        "id": "add"
      });
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.advanceSearch = {
    }

    this.setSummary();

  }

  setSummary() {
     ;
    this.SearchClear();
    this.summaryService.getSummaryData('api/EAPType/GetSummaryData').subscribe(summary => {
      this.rowData = summary
    });
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  add() {
     ;
    let modalRef = this['self'].modalService.open(EapTypeViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "",  heading: 'Add' },
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  view(){
    let modalRef = this.modalService.open(EapTypeViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: this['self'].selectedRow['ID'],  heading: 'View' }
    }
    modalRef.result.then((result) => {
      this['self'].getSummaryData();
    });
  }

  edit() {
    let id = this['self'].selectedRow['ID'];
    let modalRef = this['self'].modalService.open(EapTypeViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: {
        heading: 'Edit',
        content: { id:id,  heading: 'Edit'},
      }
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  Delete(summaryServiceCal) {
     ;
    let id = this['self'].selectedRow['ID'];
    let name = this['self'].selectedRow['NAME'];
    const modalRef1 = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false
            });
    modalRef1.componentInstance.Content =  { heading: 'Delete EAP Type', custommessage: 'Are you sure you want to delete the EAP Type ' + name+' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
    modalRef1.result.then(result => {
     {
      if(result=="okclick")
      {
        let modalRef = summaryServiceCal.Delete('api/EAPType/Delete?RecordID=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
           this['self'].commonService.SuccessBanner(summary.Message);
           this['self'].setSummary();
          }
          else {
            this['self'].commonService.ValidationBanner(summary.Message);
          }

          modalRef.content.action.subscribe(result => {
            this['self'].setSummary();
          })
        });
      }
      }
    })
  };

  SearchClear() {
    this.ETypeForm.patchValue({
      NAME: "",
      RecordSateExt: ""
    });
  }

  AdvanceSearch() {
    var formData = this.ETypeForm.value;
    this.summaryService.AdvanceSearch('api/EAPType/GetSummarySearchData', formData).subscribe(summary => {
      this.rowData = summary
    });
  }
  onRowDoubleClicked(event)
  {

  }
}
